import {
  getIntegrationCredentials,
  selectIntegrationCredentialIdsByTypeLookup,
} from "selectors";

export const getIntegrationCredentialById = integrationCredentialId => state =>
  getIntegrationCredentials(state)[integrationCredentialId] || null;

export const getIntegrationCredentialIdsByType = type => state =>
  selectIntegrationCredentialIdsByTypeLookup(state)[type] || null;
